import React, { useEffect } from 'react';
import cn from 'classnames';

import ActivationBox from '../ActivationBox';
import Button from '../../../components/common/ui/Button';
import Link from '../../../components/common/ui/Link';
import { HOME } from '../../../routes';
import { getDeviceDataFromMapping } from '../../../utils/devices';
import { resetHasNotActivatedSub } from '../../../utils/session';

import styles from './styles.module.scss';

const ActivationComplete = ({
  deviceSn,
  notActivatedSubs,
  deviceInfo,
  openDeviceSnScreen,
}) => {
  const dataFromMapping = getDeviceDataFromMapping(
    deviceInfo?.device_info?.device_type_name,
  );
  const deviceImagePath = dataFromMapping?.activationImagePath;
  const showNextActivation = Boolean(notActivatedSubs?.length);

  useEffect(() => {
    if (!showNextActivation) {
      resetHasNotActivatedSub();
    }
  }, [showNextActivation]);

  return (
    <ActivationBox className={styles.wrapper}>
      <img src={deviceImagePath} alt="" className={styles.deviceImage} />
      <div className={styles.content}>
        <h3 className={cn('h3', styles.title)}>Your device is activated!</h3>
        {!showNextActivation && (
          <p className={cn('text-s', styles.text)}>
            You can manage and view the status of your device on{' '}
            <Link className={cn('text-s', styles.link)} to={HOME}>
              dash.homefi.info
            </Link>
          </p>
        )}
        {showNextActivation ? (
          <Button onClick={openDeviceSnScreen} className={styles.button}>
            Next Activation
          </Button>
        ) : (
          <Link to={HOME}>
            <Button className={styles.button}>Open HomeFi Dash</Button>
          </Link>
        )}
      </div>
    </ActivationBox>
  );
};

export default ActivationComplete;
